module.exports = __webpack_public_path__ + "static/media/products.5a0ecc32.png";